module.exports = __webpack_public_path__ + "awards.png?5c24ac220c07a4720d5b57f64c23c666";


//////////////////
// WEBPACK FOOTER
// ./public/img/memories/awards.png
// module id = 577
// module chunks = 1